import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Column } from 'web-ui-components/lib/global/layout';
import {
  getSelectedAccountDetails,
  getAccountList,
  getAccountDetails,
} from '../../businessLogic/AccountsBL';
import * as actions from '../../redux/actions';
import { find } from 'lodash';
import { ToggleOption } from 'web-ui-components/lib/molecules/toggle';
import { Icon } from 'web-ui-components/lib/atoms/iconography';
import { TogglePanel } from 'web-ui-components/lib/molecules/panels';
import { DaySelector } from 'web-ui-components/lib/molecules/forms';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { Card } from 'web-ui-components/lib/organisms/cards';
import { CommonModal } from '../../components/common/CommonModal';
import { ButtonGroup } from 'web-ui-components/lib/molecules/buttons';

export class AlertTypeWBA extends Component {
  constructor(props) {
    super(props);
    this.confirmWBAChanges = this.confirmWBAChanges.bind(this);
    this.checkAccountDetails = this.checkAccountDetails.bind(this);
    this.changeHandler = this.changeHandler.bind(this);
    this.clickCancel = this.clickCancel.bind(this);
    this.toggleOptionFactory = this.toggleOptionFactory.bind(this);
    this.closeErrorModal = this.closeErrorModal.bind(this);
    this.onPrimaryBtnClick = this.onPrimaryBtnClick.bind(this);
    this.setWBAToggleContent = this.setWBAToggleContent.bind(this);
  }

  componentDidMount() {
    const { selectedDay, showButtonOptions, toggleCheck } = this.props;
    selectedDay(this.daySelector('id'));
    showButtonOptions(false);
    // to display value of weekly balance alert when component gets mount
    const wbaDetails = this.checkWBAEligible();
    toggleCheck(wbaDetails.enabled);
  }

  componentWillReceiveProps() {
    const wbaDetails = this.checkWBAEligible();
    this.props.toggleCheck(wbaDetails.enabled);
  }
  daySelector(value) {
    const days = [
      { id: 1, day: 'Monday' },
      { id: 2, day: 'Tuesday' },
      { id: 3, day: 'Wednesday' },
      { id: 4, day: 'Thursday' },
      { id: 5, day: 'Friday' },
      { id: 6, day: 'Saturday' },
      { id: 7, day: 'Sunday' },
    ];
    switch (value) {
      case 'id':
        return this.checkWBAEligible().hasOwnProperty('day_of_week')
          ? find(days, { day: this.checkWBAEligible().day_of_week }).id || {}
          : 1;
      case 'day':
        return find(days, { id: this.props.daySelected }).day || {};
    }
  }

  checkAccountDetails() {
    const { accountList, selectedAccountId } = this.props;
    const validAccountList = getAccountList(accountList.accounts);
    const accountDetails = getAccountDetails(selectedAccountId, validAccountList);
    return accountDetails;
  }

  checkWBAEligible() {
    const { selectedAccountId } = this.props;
    const { WBAAlert } = this.props.WBAAlertList;
    let WBAList = [];
    if (!WBAAlert.hasOwnProperty('account_alerts')) {
      WBAList.push({
        account_id: selectedAccountId,
        day_of_week: WBAAlert.day_of_week,
        enabled: WBAAlert.enabled,
      });
    } else {
      WBAList = WBAAlert.account_alerts;
    }
    return getSelectedAccountDetails(selectedAccountId, WBAList);
  }

  confirmWBAChanges(value) {
    const wbaDetails = this.checkWBAEligible();
    const {
      updateWeeklyBalanceAlert,
      showButtonOptions,
      toggleFlag,
      editModeEnabled,
      getWeeklyBalanceAlert,
    } = this.props;
    const reqData = { account_id: this.checkAccountDetails().id };
    let reqBody;
    switch (value) {
      case 'toggle':
        reqBody = {
          day_of_week: wbaDetails.hasOwnProperty('day_of_week') ? wbaDetails.day_of_week : 'Monday',
          enabled: !toggleFlag,
        };
        this.props.selectedDay(this.daySelector('id'));
        break;
      case 'day':
        reqBody = { day_of_week: this.daySelector('day'), enabled: toggleFlag };
        break;
    }
    updateWeeklyBalanceAlert(reqData, reqBody, value).then(() => {
      getWeeklyBalanceAlert();
    });
    showButtonOptions(false);
    editModeEnabled(false);
  }

  changeHandler(dayIndex) {
    const { selectedDay, showButtonOptions, editModeEnabled } = this.props;
    if (dayIndex) {
      editModeEnabled(true);
    }
    selectedDay(dayIndex, () => {
      this.daySelector('day');
    });
    showButtonOptions(dayIndex !== this.daySelector('id'));
  }

  clickCancel() {
    const { showButtonOptions, selectedDay, editModeEnabled } = this.props;
    showButtonOptions(false);
    selectedDay(this.daySelector('id'));
    editModeEnabled(false);
  }
  setWBAToggleContent() {
    const { toggleFlag, content } = this.props;
    return toggleFlag ? content.WBAAlertToggleText : content.WBABodyText;
  }
  toggleOptionFactory() {
    const { toggleFlag } = this.props;
    const { WBATitle } = this.props.content;
    return (
      <ToggleOption
        icon={
          <Icon iconType="CalendarOutlineLarge" className="c-a-button__icon" direction="right" />
        }
        title={WBATitle}
        blurb={this.setWBAToggleContent()}
        active={toggleFlag}
        onChange={() => this.confirmWBAChanges('toggle')}
      />
    );
  }

  closeErrorModal() {
    this.props.closeErrorPopup(false);
  }

  onPrimaryBtnClick() {
    this.confirmWBAChanges(this.props.WBAError.activeElement === 'toggle' ? 'toggle' : 'day');
  }

  errorModal() {
    return (
      <CommonModal
        isOpen={this.props.WBAError.isError}
        onRequestClose={this.closeErrorModal}
        onPrimaryBtnClick={() => this.onPrimaryBtnClick()}
      />
    );
  }

  render() {
    const { isDisabled, toggleFlag, daySelected, WBAError } = this.props;
    const { cancel, confirm } = this.props.content;
    return (
      <Column className="u-margin-top-1 u-margin-bottom-1">
        <Card bordered>
          <TogglePanel
            toggleOptionFactory={this.toggleOptionFactory}
            active={toggleFlag}
            onChange={() => this.confirmWBAChanges('toggle')}
          >
            <br />
            <DaySelector onChange={this.changeHandler} selected={daySelected} />
            {isDisabled && (
              <ButtonGroup>
                <Button className="u-margin-right-2" display="secondary" onClick={this.clickCancel}>
                  {cancel}
                </Button>
                <Button display="primary" onClick={() => this.confirmWBAChanges('day')}>
                  {confirm}
                </Button>{' '}
              </ButtonGroup>
            )}
            <br />
          </TogglePanel>
        </Card>
        {WBAError.isError && this.errorModal()}
      </Column>
    );
  }
}
AlertTypeWBA.propTypes = {
  selectedDay: PropTypes.func.isRequired,
  toggleCheck: PropTypes.func.isRequired,
  accountList: PropTypes.shape({}),
  selectedAccountId: PropTypes.string,
  WBAAlertList: PropTypes.shape({
    WBAAlert: PropTypes.shape({}),
  }),
  content: PropTypes.shape({
    WBATitle: PropTypes.string.isRequired,
    WBABodyText: PropTypes.string.isRequired,
    cancel: PropTypes.string.isRequired,
    confirm: PropTypes.string.isRequired,
  }),
  updateWeeklyBalanceAlert: PropTypes.func.isRequired,
  closeErrorPopup: PropTypes.func.isRequired,
  showButtonOptions: PropTypes.func.isRequired,
  toggleFlag: PropTypes.bool.isRequired,
  WBAError: PropTypes.bool,
  isDisabled: PropTypes.bool.isRequired,
  daySelected: PropTypes.any,
  editModeEnabled: PropTypes.func,
  getWeeklyBalanceAlert: PropTypes.func,
};

const mapStateToProps = ({ accountList, WBAAlert }) => {
  return {
    accountList: accountList.get('accountList'),
    selectedAccountId: accountList.get('selectedAccountId'),
    WBAAlertList: WBAAlert.get('WBAAlert'),
    isDisabled: WBAAlert.get('isDisabled'),
    daySelected: WBAAlert.get('daySelected'),
    toggleFlag: WBAAlert.get('toggleFlag'),
    WBAError: WBAAlert.get('isError'),
  };
};
const mapDispatch = (dispatch) => bindActionCreators(actions, dispatch);

export default connect(mapStateToProps, mapDispatch)(AlertTypeWBA);
